import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventComponent } from './event.component';
import { EventStepOneComponent } from './components/event-step-one/event-step-one.component';
import { EventStepTwoComponent } from './components/event-step-two/event-step-two.component';
import { EventStepThreeComponent } from './components/event-step-three/event-step-three.component';
import { EventStepFourComponent } from './components/event-step-four/event-step-four.component';
import { UnsavedChangesGuard } from 'src/app/shared/services/unsaved-changes.guard';

const eventRoutes: Routes = [
  { path: '', component: EventComponent,
    canDeactivate: [UnsavedChangesGuard]
   },
  { path: 'edit/:id', component: EventComponent,
    canDeactivate: [UnsavedChangesGuard]
   },
];

@NgModule({
  declarations: [
    EventComponent,
    EventStepOneComponent,
    EventStepTwoComponent,
    EventStepThreeComponent,
    EventStepFourComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(eventRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class EventModule { }
